import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwOrmDataService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { StudentAssignmentProgressEvent, studentAssignmentProgress } from "../models/student-assignment-progress-event.model";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { ResetStudentAssignmentRequest } from "../models/reset-student-assignment-request.model";
import { StudentCourseProgressRequest } from "../models/student-course-progress-request.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";

@DwAction({
    keyName: 'student-course-delete',
    display: 'Student - Remove Course',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.StudentCourse,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Remove Course',
        iconClass: 'fa fa-trash',
        buttonClass: 'btn btn-danger',
        buttonTitle: 'Removes the course from this student (Course progress must be at 0%)'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        // permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true,
        permissionMeaning: AppPermissions.studentCourseCanDelete
    },
    defaultConfirmConfig :{
        showDialogConfig: true,
        showConfirmDialog: true,
        message: 'Are you sure?  This cannot be undone!',
        title: 'Remove Course for Student'
    }
})
@Injectable()
export class StudentCourseDeleteActionService implements DwMdFormActionHandler {

    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private schoolRespositoryService: SchoolRepositoryService,
        private dwEventService: DwEventService
    ) {
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {

        const studentCourse = actionState.formApi.getFormData<StudentCourseEntity>();

        const resetRequest: StudentCourseProgressRequest = {
            studentCourseId: studentCourse.StudentCourseId
        };

        return this.schoolRespositoryService.deleteStudentCourse(resetRequest)
            .pipe(map((resetResult) => {
                const result: DwActionResult = {
                    success: resetResult.IsSuccess
                };

                if (resetResult.ErrorMessage) {
                    result.message = `Error delete course for student Error: ${resetResult.ErrorMessage} `
                } else {
                    result.message = 'Student course deleted';

                    actionState.formApi.cancel();
                }

                this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.DwUser), {});

                return result;
            }));
    }
}